import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Environment = {
    _v1: {
        getCertData: { method: HttpMethod.POST, path: '/v1/get-env-cert-data' },
        getQuaiEnvironments: { method: HttpMethod.GET, path: '/v1/get-quai-environments' },
        getEnvironment: { method: HttpMethod.GET, path: '/v1/get-environment' },
        buildOrganizationData: { method: HttpMethod.GET, path: '/v1/get-organization-data' },
        getJwksEpicPrd: { method: HttpMethod.GET, path: '/v1/jwks/epic-prd' },
        getJwksEpicNonprd: { method: HttpMethod.GET, path: '/v1/jwks/epic-nonprd' },
        getJwksFhirEpic: { method: HttpMethod.GET, path: '/v1/jwks/fhir-epic' }
    }
};
//# sourceMappingURL=api-def.js.map